//const BaseURL = "http://localhost/bapenda-bekasi-backend/";
const BaseURL = "https://bapenda.bekasikota.go.id/bapenda-bekasi-backend/";


export default BaseURL;
